import { Link } from "@mui/material";
import { AppGlobalClassKeys } from "app/appGlobalStyles";
import { MprcLink } from "components";
import { NotificationAction, NotificationWorkspaceDto } from "generated/CoreApi_v1";
import { t } from 'i18next';
import HtmlUtils from "lib/HtmlUtils";
import LibUtils from "lib/LibUtils";
import { coreApiV1 } from "providers/CoreApiProvider";
import React, { ReactNode } from "react";
import { NavigateOptions, To, useNavigate } from "react-router";
import { RootPaths } from "routes/RootRouter";
import { UserProfileDialog } from "views/foundation/user/dialogs/UserProfileDialog";
import { ListUsersDrawer } from "views/foundation/user/drawers/ListUsersDrawer";

////////////////////////////////////////////////////////////////////////////////

export class MessengerResolver {

    /** Id correspondente a */
    static messengerId: string[];

    ////////////////////////////////////////////////////////////////////////////////

    protected notification: NotificationWorkspaceDto;
    protected notificationAction: NotificationAction | null;
    protected notificationActionKeys: any[] | null;

    private navigate = useNavigate();

    protected onCloseMenu: () => void;
    protected renderDialog: (dialog: any) => void;

    constructor(item: NotificationWorkspaceDto, onCloseMenu: () => void, renderDialog: (dialog: any) => void) {
        this.onCloseMenu = onCloseMenu;
        this.renderDialog = renderDialog;
        this.notification = item;
        this.notificationAction = item.regularNotification!.action;
        this.notificationActionKeys = (this.notificationAction != null && this.notificationAction.keys.length > 0) ? this.notificationAction.keys : null;
    }

    ////////////////////////////////////////////////////////////////////////////////

    protected translateToken(token: string): ReactNode {
        return token;
    }

    protected translateAction(): ReactNode {
        return null;
    }

    protected translateUser(): ReactNode {
        const listUsersDrawer =
            <ListUsersDrawer
                title={this.notificationAction?.title ?? "?"}
                onGetData={
                    (p, signal) => {
                        return new Promise((resolve, reject) => {
                            coreApiV1.notification.getWorkspaceMessageUsers({ notificationId: this.notification.notificationId, ...p }, { signal })
                                .then((data) => resolve(data.data))
                                .catch((e) => reject(e));
                        });
                    }
                }
                onClose={() => this.renderDialog(null)}
            />;

        return (
            <>
                {
                    this.notification?.regularNotification?.firstUserId != null && this.notification.regularNotification?.totalUsers == 1
                        ? <b>{this.userProfileLink(this.notification.regularNotification.firstUserId, this.notification.regularNotification.firstUserName!)}</b>
                        : this.notification?.regularNotification?.totalUsers != null && this.notification.regularNotification.totalUsers > 1
                            ? <Link color="primary.light" onClick={() => this.renderDialog(listUsersDrawer)}>
                                {`${this.notification.regularNotification!.firstUserName} ${t("shared:Notifications.Common.Others", { count: this.notification.regularNotification.totalUsers - 1 })}`}
                            </Link>
                            : <span>?</span>
                }
            </>
        );
    }

    protected nav(path: To, options?: NavigateOptions) {
        this.onCloseMenu();
        this.navigate(path, options);
    }

    protected userProfileLink(id: string, name: string): ReactNode {
        return id && name
            ? (
                <MprcLink
                    key={(new Date()).getDate()}
                    color="highlight.main"
                    title={name}
                    onClick={() => this.renderDialog(<UserProfileDialog userId={id} onClose={() => this.renderDialog(null)} />)}
                >
                    {LibUtils.firstWord(name)}
                </MprcLink>
            )
            : name ?? "?";
    }

    protected userProfileNewWindowLink(id: string, name: string) {
        return id && name
            ? (
                <MprcLink
                    key={(new Date()).getDate()}
                    color="highlight.main"
                    title={name}
                    onClick={() => HtmlUtils.openUrlInNewWindow(RootPaths.BuildUserProfile(id), id)}
                >
                    {LibUtils.firstWord(name)}
                </MprcLink>
            )
            : name ?? "?";
    }

    get action(): (() => void) | undefined {
        return undefined;
    }

    get message(): React.ReactNode {

        var message = this.notification.regularNotification!.message.split('\n');
        const line1 = this.convertMessage(LibUtils.tokenizerString(message[0]));

        if (message.length == 2) {
            const line2 = this.convertMessage(LibUtils.tokenizerString(message[1]));
            return <div>{line1}<br />{line2}</div>;
        }

        return <div>{line1}</div>;
    }

    private convertMessage(tokens: string[]) {
        let doubleSpace = false;
        let bufferLine: Array<any> = [];
        let lines: Array<any> = [];

        tokens.reduce((acc: Array<any>, s: string, index: number) => {
            var content: React.ReactNode = null;

            if (s == "\n" || s == "\\n") {
                lines.push(bufferLine);
                bufferLine = [];
                content = null;
                doubleSpace = false;
            }
            else if (s == " ") {
                if (!doubleSpace)
                    content = s;
                else {
                    content = null;
                    doubleSpace = true;
                }
            }
            else {
                doubleSpace = false;
                if (s == "[action]") content = this.translateAction();
                else if (s == "[user]") content = this.translateUser();
                else if (s == "[actionTitle]") content = <b>{this.notificationAction?.title ?? ""}</b>;
                else content = this.translateToken(s);
            }

            if (content != null) {
                bufferLine.push(content);
            }

            return acc;
        }, []);

        if (bufferLine.length > 0) lines.push(bufferLine);

        return lines.map((line, index) => {
            return index > 0
                ? (
                    <React.Fragment key={index}>
                        <div className={AppGlobalClassKeys.truncateLine}>
                            <span>{line}</span>
                        </div>
                    </React.Fragment>
                )
                : <span key={index}>{line}</span>;
        });
    }

}
